/* eslint-disable react/react-in-jsx-scope */
import React from 'react';
import StarRating from 'gatsby-core-theme/src/components/molecules/star-rating/one-star';
import { FaStar } from '@react-icons/all-files/fa/FaStar';

export const operatorRatings = {
  operator: [
    {
      fieldLabel: 'Overall',
      translationKey: 'rating',
      fieldValue: 'rating',
      componentToUse: (numOfStars, value) => (
        <StarRating numOfStars={numOfStars} rating={value} icon={<FaStar title="Star Icon" />} />
      ),
      showOnlyMobile: true,
    },
    {
      fieldLabel: 'Bonus',
      translationKey: 'bonus_offers',
      fieldValue: 'rating_bonuses',
      componentToUse: (numOfStars, value) => (
        <StarRating numOfStars={numOfStars} rating={value} icon={<FaStar title="Star Icon" />} />
      ),
    },
    {
      fieldLabel: 'Payment',
      translationKey: 'rating_payout',
      fieldValue: 'rating_payout',
      componentToUse: (numOfStars, value) => (
        <StarRating numOfStars={numOfStars} rating={value} icon={<FaStar title="Star Icon" />} />
      ),
    },
    {
      fieldLabel: 'Support',
      translationKey: 'rating_customer',
      fieldValue: 'rating_customer',
      componentToUse: (numOfStars, value) => (
        <StarRating numOfStars={numOfStars} rating={value} icon={<FaStar title="Star Icon" />} />
      ),
    },
    {
      fieldLabel: 'Games',
      translationKey: 'rating_games',
      fieldValue: 'rating_games',
      componentToUse: (numOfStars, value) => (
        <StarRating numOfStars={numOfStars} rating={value} icon={<FaStar title="Star Icon" />} />
      ),
    },
  ],
  sportsbook: [
    {
      fieldLabel: 'Overall',
      translationKey: 'rating',
      fieldValue: 'rating',
      componentToUse: (numOfStars, value) => (
        <StarRating numOfStars={numOfStars} rating={value} icon={<FaStar title="Star Icon" />} />
      ),
      showOnlyMobile: true,
    },
    {
      fieldLabel: 'Bonus',
      translationKey: 'bonus_offers',
      fieldValue: 'rating_bonuses',
      componentToUse: (numOfStars, value) => (
        <StarRating numOfStars={numOfStars} rating={value} icon={<FaStar title="Star Icon" />} />
      ),
    },
    {
      fieldLabel: 'Payment',
      translationKey: 'rating_payout',
      fieldValue: 'rating_payout',
      componentToUse: (numOfStars, value) => (
        <StarRating numOfStars={numOfStars} rating={value} icon={<FaStar title="Star Icon" />} />
      ),
    },
    {
      fieldLabel: 'Support',
      translationKey: 'rating_customer',
      fieldValue: 'rating_customer',
      componentToUse: (numOfStars, value) => (
        <StarRating numOfStars={numOfStars} rating={value} icon={<FaStar title="Star Icon" />} />
      ),
    },
    {
      fieldLabel: 'Games',
      translationKey: 'rating_games',
      fieldValue: 'rating_games',
      componentToUse: (numOfStars, value) => (
        <StarRating numOfStars={numOfStars} rating={value} icon={<FaStar title="Star Icon" />} />
      ),
    },
  ],
  game: [
    {
      fieldLabel: 'Overall',
      translationKey: 'rating',
      fieldValue: 'average_rating',
      componentToUse: (numOfStars, value) => (
        <StarRating numOfStars={numOfStars} rating={value} icon={<FaStar title="Star Icon" />} />
      ),
      showOnlyMobile: true,
    },
    {
      fieldLabel: 'Graphics',
      translationKey: 'graphics',
      fieldValue: 'first_rating',
      componentToUse: (numOfStars, value) => (
        <StarRating numOfStars={numOfStars} rating={value} icon={<FaStar title="Star Icon" />} />
      ),
    },
    {
      fieldLabel: 'Gameplay',
      translationKey: 'gameplay',
      fieldValue: 'second_rating',
      componentToUse: (numOfStars, value) => (
        <StarRating numOfStars={numOfStars} rating={value} icon={<FaStar title="Star Icon" />} />
      ),
    },
    {
      fieldLabel: 'Bonuses',
      translationKey: 'bonuses',
      fieldValue: 'third_rating',
      componentToUse: (numOfStars, value) => (
        <StarRating numOfStars={numOfStars} rating={value} icon={<FaStar title="Star Icon" />} />
      ),
    },
    {
      fieldLabel: 'Features',
      translationKey: 'value',
      fieldValue: 'fourth_rating',
      componentToUse: (numOfStars, value) => (
        <StarRating numOfStars={numOfStars} rating={value} icon={<FaStar title="Star Icon" />} />
      ),
    },
    {
      fieldLabel: 'Game Provider',
      translationKey: 'game_provider',
      fieldValue: 'game_provider.name',
    },
    {
      fieldLabel: 'Volatility',
      translationKey: 'volatility',
      fieldValue: 'volatility',
    },
  ],
  payment_method: [
    {
      fieldLabel: 'Rating',
      translationKey: 'rating_payment',
      fieldValue: 'rating',
      componentToUse: (numOfStars, value) => (
        <StarRating numOfStars={numOfStars} rating={value} icon={<FaStar title="Star Icon" />} />
      ),
      showOnlyMobile: true,
    },
    {
      fieldLabel: 'Payout',
      translationKey: 'payout',
      fieldValue: 'payout_time',
    },
    {
      fieldLabel: 'Min. Deposit',
      translationKey: 'min_deposit',
      fieldValue: 'min_deposit',
      componentToUse: (numOfStars, value, currency) => {
        if ((/N\/A|NA|-/i).test(value)) {
          return '-';
        }
        
        return (
          <>{value ? `${currency}${value}` : "-"}</>
        )
      },
    },
    {
      fieldLabel: 'Email',
      translationKey: 'email',
      fieldValue: 'support_types',
      componentToUse: (numOfStars, value) => {
        if (value && value?.length > 0) {
          return (
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                opacity="0.99"
                d="M10.3126 16.0938C10.1812 16.094 10.0512 16.0682 9.92984 16.0179C9.80851 15.9676 9.69831 15.8938 9.60558 15.8008L6.79308 12.9884C6.60751 12.8004 6.50382 12.5468 6.50464 12.2827C6.50547 12.0186 6.61074 11.7655 6.79748 11.5788C6.98423 11.392 7.23727 11.2867 7.50136 11.2859C7.76546 11.2851 8.01916 11.3887 8.20708 11.5743L10.3125 13.6798L15.7931 8.1993C15.981 8.01374 16.2347 7.91006 16.4988 7.91089C16.7629 7.91173 17.0159 8.01702 17.2027 8.20376C17.3894 8.39051 17.4947 8.64356 17.4955 8.90765C17.4963 9.17175 17.3926 9.42545 17.2071 9.61336L11.0196 15.8009C10.9268 15.8939 10.8166 15.9676 10.6953 16.0179C10.574 16.0682 10.4439 16.094 10.3126 16.0938Z"
                fill="#272735"
              />
              <path
                d="M12 2C10.0222 2 8.08879 2.58649 6.4443 3.6853C4.79981 4.78412 3.51809 6.3459 2.76121 8.17317C2.00433 10.0004 1.8063 12.0111 2.19215 13.9509C2.578 15.8907 3.53041 17.6725 4.92894 19.0711C6.32746 20.4696 8.10929 21.422 10.0491 21.8079C11.9889 22.1937 13.9996 21.9957 15.8268 21.2388C17.6541 20.4819 19.2159 19.2002 20.3147 17.5557C21.4135 15.9112 22 13.9778 22 12C21.997 9.34877 20.9424 6.80699 19.0677 4.93228C17.193 3.05758 14.6512 2.00303 12 2ZM17.207 9.61328L11.0195 15.8008C10.9267 15.8937 10.8165 15.9673 10.6951 16.0176C10.5738 16.0679 10.4438 16.0938 10.3125 16.0938C10.1812 16.0938 10.0511 16.0679 9.92981 16.0176C9.8085 15.9673 9.69828 15.8937 9.60544 15.8008L6.793 12.9883C6.60743 12.8004 6.50374 12.5467 6.50457 12.2826C6.50539 12.0185 6.61067 11.7654 6.79741 11.5787C6.98415 11.3919 7.23719 11.2867 7.50129 11.2858C7.76538 11.285 8.01908 11.3887 8.207 11.5742L10.3125 13.6797L15.793 8.19922C15.9809 8.01366 16.2346 7.90998 16.4987 7.91081C16.7628 7.91165 17.0159 8.01694 17.2026 8.20368C17.3893 8.39043 17.4946 8.64348 17.4954 8.90757C17.4963 9.17167 17.3926 9.42537 17.207 9.61328Z"
                fill="#5CE482"
              />
            </svg>
          );
        }
        return (
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M13.4144 12L16.7074 8.70696C16.8929 8.51904 16.9966 8.26533 16.9958 8.00124C16.995 7.73714 16.8897 7.4841 16.7029 7.29736C16.5162 7.11062 16.2631 7.00535 15.999 7.00452C15.7349 7.0037 15.4812 7.10739 15.2933 7.29296L12.0003 10.5859L8.70732 7.29296C8.51923 7.10825 8.26581 7.00529 8.0022 7.00648C7.73858 7.00768 7.4861 7.11293 7.2997 7.29933C7.11329 7.48574 7.00804 7.73822 7.00685 8.00183C7.00565 8.26545 7.10861 8.51887 7.29332 8.70696L10.5863 12L7.29332 15.293C7.10861 15.481 7.00565 15.7345 7.00685 15.9981C7.00804 16.2617 7.11329 16.5142 7.2997 16.7006C7.4861 16.887 7.73858 16.9922 8.0022 16.9934C8.26581 16.9946 8.51923 16.8917 8.70732 16.707L12.0003 13.414L15.2933 16.707C15.4812 16.8926 15.7349 16.9963 15.999 16.9954C16.2631 16.9946 16.5162 16.8893 16.7029 16.7026C16.8897 16.5158 16.9949 16.2628 16.9958 15.9987C16.9966 15.7346 16.8929 15.4809 16.7073 15.293L13.4144 12Z"
              fill="#272735"
            />
            <path
              d="M19.0704 4.92919C17.1951 3.05389 14.6517 2.00037 11.9996 2.00037C9.34756 2.00037 6.80411 3.05389 4.92882 4.92919C3.05353 6.80448 2 9.34792 2 12C2 14.6521 3.05353 17.1955 4.92882 19.0708C6.80411 20.9461 9.34756 21.9996 11.9996 21.9996C14.6517 21.9996 17.1951 20.9461 19.0704 19.0708C20.9457 17.1955 21.9992 14.6521 21.9992 12C21.9992 9.34792 20.9457 6.80448 19.0704 4.92919ZM16.7066 15.293C16.8009 15.3855 16.8758 15.4958 16.9272 15.6175C16.9786 15.7392 17.0053 15.8698 17.0059 16.0019C17.0065 16.1339 16.9809 16.2648 16.9307 16.3869C16.8804 16.5091 16.8064 16.62 16.7131 16.7134C16.6197 16.8068 16.5087 16.8808 16.3866 16.931C16.2644 16.9813 16.1336 17.0069 16.0015 17.0063C15.8694 17.0057 15.7388 16.9789 15.6171 16.9275C15.4954 16.8762 15.3852 16.8012 15.2926 16.707L11.9996 13.414L8.70662 16.707C8.51853 16.8917 8.26511 16.9947 8.0015 16.9935C7.73788 16.9923 7.4854 16.887 7.299 16.7006C7.11259 16.5142 7.00734 16.2617 7.00615 15.9981C7.00495 15.7345 7.10791 15.4811 7.29262 15.293L10.5856 12L7.29262 8.70699C7.10791 8.5189 7.00495 8.26548 7.00615 8.00186C7.00734 7.73825 7.11259 7.48577 7.299 7.29936C7.4854 7.11296 7.73788 7.00771 8.0015 7.00651C8.26511 7.00532 8.51853 7.10828 8.70662 7.29299L11.9996 10.5859L15.2926 7.29293C15.4805 7.10737 15.7342 7.00368 15.9983 7.00452C16.2624 7.00536 16.5155 7.11064 16.7022 7.29739C16.889 7.48414 16.9942 7.73719 16.9951 8.00128C16.9959 8.26538 16.8922 8.51907 16.7066 8.70699L13.4137 12L16.7066 15.293Z"
              fill="#F2281D"
            />
          </svg>
        );
      },
    },
  ],
  operatorCards: [
    {
      fieldLabel: 'Games',
      translationKey: 'games',
      fieldValue: 'rating_casino',
      componentToUse: (numOfStars, value) => (
        <StarRating numOfStars={numOfStars} rating={value} icon={<FaStar title="Star Icon" />} />
      ),
    },
    {
      fieldLabel: 'Bonuses',
      translationKey: 'bonus_offers',
      fieldValue: 'rating_bonuses',
      componentToUse: (numOfStars, value) => (
        <StarRating numOfStars={numOfStars} rating={value} icon={<FaStar title="Star Icon" />} />
      ),
    },
    {
      fieldLabel: 'Support',
      translationKey: 'customer_service',
      fieldValue: 'rating_games',
      componentToUse: (numOfStars, value) => (
        <StarRating numOfStars={numOfStars} rating={value} icon={<FaStar title="Star Icon" />} />
      ),
    },
  ],
  ratingProperties: [
    'rating_bonuses',
    'rating_casino',
    'rating_customer',
    'rating_games',
    'rating_payout',
    'first_rating',
    'second_rating',
    'third_rating',
    'fourth_rating',
  ],
  extraRatings: [
    {
      fieldLabel: 'Game Provider',
      translationKey: 'game_provider',
      fieldValue: 'game_provider.name',
    },
    {
      fieldLabel: 'Volatility',
      translationKey: 'volatility',
      fieldValue: 'volatility',
    },
  ],
};
